<template>
  <tr>
    <td class="text-center">
      <span class="form-control form-control-plaintext">{{rowIndex + 1}}</span>
    </td>
    <td class="form-group">
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'brtEmployee' + _uid"
        :name="'brtEmployee' + _uid"
        :select2-options="brtEmployeeOptions"
        @selectChange="onEmployeeChange"
        v-model="brtEmployee"
        ref="brtEmployee"
        data-msg-required="กรุณาเลือกพนักงาน"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <center>
        <a
          href="#"
          @click.prevent="detail"
          title="รายละเอียด"
          class="btn btn-sm btn-clean btn-icon btn-icon-md"
        >
          <i class="text-info far fa-file-alt"></i>
        </a>
        <button
          type="button"
          class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
          @click.prevent="onRemoveBRTItemClick"
        >
          <i class="text-danger la la-trash"></i>
        </button>
      </center>
    </td>
  </tr>
</template>
<script>
import select2 from "../../../Shared/Select2";
import router from "../../../router";

export default {
  components: {
    select2
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data: function() {
    var self = this;

    return {
      brtEmployee: self.item.brtEmployeeRow,
      brtEmployeeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    onEmployeeChange: function(id, text, data, ref) {
      this.item.brtEmployeeRow = this.brtEmployee;
      this.item.selectedEmployeeRow = {
        id: data[0].id,
        text: data[0].text
      };
    },
    onRemoveBRTItemClick(e) {
      var self = this;
      self.$emit("removeItem", self.rowIndex, self.item);
    },
    detail() {
      var self = this;
      if (self.brtEmployee != null)
        if (self.$parent.edit)
          router.push({
            path: `/Master/Approver/Edit/${self.$parent.uaApproveGroupID}/Employee/${self.brtEmployee}`
          });
        else
          router.push({
            path: `/Master/Approver/Add/Employee/${self.brtEmployee}`
          });
      else Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกพนักงาน", "error");
    }
  }
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/Approver/BRTItemRow.vue